import type { RouteRecordRaw } from 'vue-router';

export const timetableRoutes: RouteRecordRaw = {
  path: 'timetable',
  components: {
    default: () => import('@/layouts/modules/timetable/TimetableLayout.vue'),
    sidebar: () => import('@/layouts/modules/timetable/TimetableAside.vue')
  },
  children: [
    // Global Timetable Routes
    {
      path: 'global-room-types',
      name: 'GlobalRoomTypes',
      component: () => import('@/views/modules/timetable/GlobalRoomTypes.vue'),
    },

    // School Timetable Routes
    {
      path: 'school',
      children: [
        {
          path: 'support-areas',
          name: 'SupportAreas',
          component: () => import('@/views/modules/timetable/school/SchoolSupportAreasView.vue'),
        },
        {
          path: 'room-types',
          name: 'SchoolRoomTypes',
          component: () => import('@/views/modules/timetable/school/SchoolRoomTypes.vue'),
        },
        {
          path: 'settings',
          name: 'schoolTimetableSettings',
          component: () => import('@/views/modules/timetable/school/SchoolTimetableSettingsView.vue'),
        }
      ]
    }
  ]
};